import axios, { AxiosInstance } from 'axios'

// Single typed axios instance for the whole app — every API call goes through this client so
// base URL, timeout and auth/retry behavior stay in one place instead of being re-declared per
// call site.
const apiClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_SERVICE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor hook point. A real app wires token attachment/refresh here (see Resactly's
// src/helpers/axios.ts for the full pattern: single-flight refresh + 401 retry-once). Left as a
// pass-through here since this scaffold ships with no auth provider.
apiClient.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error),
)

// Response interceptor hook point — same idea, kept as a pass-through for the same reason.
apiClient.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error),
)

export default apiClient
